import { render } from "./externaldataset-list.vue?vue&type=template&id=927e93e8&scoped=true"
import script from "./externaldataset-list.vue?vue&type=script&lang=js"
export * from "./externaldataset-list.vue?vue&type=script&lang=js"

import "./externaldataset-list.vue?vue&type=style&index=0&id=927e93e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927e93e8"]])

export default __exports__